import clsx from "clsx";
import { ReactNode } from "react";

import "./StackableButtonGroup.scss";

type StackableButtonGroupProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Renders one or more `StackableButton` components in a group
 */
export const StackableButtonGroup = (props: StackableButtonGroupProps) => {
  return (
    <div className={clsx("ap-stackable-button-group", props.className)}>
      {props.children}
    </div>
  );
};
